export default __webpack_public_path__ + "static/media/p8.c51b6aad.jpeg";